import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const ScreenIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="16"
        height="15"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.75 1.5C2.05964 1.5 1.5 2.05964 1.5 2.75V8.25C1.5 8.94036 2.05964 9.5 2.75 9.5H13.25C13.9404 9.5 14.5 8.94036 14.5 8.25V2.75C14.5 2.05964 13.9404 1.5 13.25 1.5H2.75ZM0 2.75C0 1.23122 1.23122 0 2.75 0H13.25C14.7688 0 16 1.23122 16 2.75V8.25C16 9.76878 14.7688 11 13.25 11H2.75C1.23122 11 0 9.76878 0 8.25V2.75Z"
          fill="#8F8E8A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.49302 12.7954C4.47327 12.4379 6.0383 12 8 12C9.9617 12 11.5267 12.4379 12.507 12.7954C12.8961 12.9373 13.0965 13.3678 12.9546 13.757C12.8127 14.1461 12.3822 14.3465 11.993 14.2046C11.1253 13.8881 9.7383 13.5 8 13.5C6.2617 13.5 4.87473 13.8881 4.00698 14.2046C3.61784 14.3465 3.18733 14.1461 3.0454 13.757C2.90347 13.3678 3.10388 12.9373 3.49302 12.7954Z"
          fill="#8F8E8A"
        />
      </svg>
    </SvgIcon>
  )
}

export default ScreenIcon
